import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main.vue'
import Loader from '@/components/Loader.vue'
import Login from '@/components/login/Login.vue'
//import PinDialog from '@/components/dialogs/PinDialog.vue'
//import LanguageLoader from '@/components/LanguageLoader.vue'
import AddClient from '@/components/AddClient.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      component: Loader
    },
    {
      path: "/loading",
      name: 'Loader',
      component: Loader
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/addclient',
      name: 'AddClient',
      component: AddClient
    },
    {
      path: '/main',
      name: 'Main',
      component: Main
    },
    /*{
      path: '/dialogs',
      name: 'PinDialog',
      component: PinDialog
    },
    {
      path: '/',
      name: 'LanguageLoader',
      component: LanguageLoader
    }*/
  ]
})